import { CommonModule } from "@angular/common"
import { Component, EventEmitter, Output } from "@angular/core"
import { AngularSvgIconModule } from "angular-svg-icon"
import { ButtonModule } from "primeng/button"

@Component({
	selector: "app-layout-sidebar-header",
	imports: [CommonModule, AngularSvgIconModule, ButtonModule],
	// PrimeNG services are provided at application level in appConfig
	standalone: true,
	templateUrl: "./header.html"
})
export class LayoutSidebarHeader {
	@Output("menu") public menuEmitter: EventEmitter<void> = new EventEmitter<void>()

	public emitMenu() {
		this.menuEmitter.emit()
	}
}
